export const RISKS_FIELD: any = {
  id: "ID",
  riskCode: "LEVEL_ONE_RISK_CODE",
  riskName: "LEVEL_ONE_RISK_NAME",
  riskStatus: "LEVEL_ONE_RISK_STATUS",
  riskDescription: "LEVEL_ONE_RISK_DESCRIPTION",
  category: "LEVEL_TWO_RISK_CATEGORY",
  // parent: "PARENT",
  subNodes: "SUB_NODES"
};